import styled from 'styled-components';
import { Link } from '@material-ui/core';
import { Link as LinkRouter } from 'react-router-dom';

export const Iframe = styled.iframe`
	height: 82%;
`;

export const LiStyled = styled.li`
	margin: 2px 0px;
	&.sds-list__item--active {
		background: ${(props) => props.theme.colors.menuActived} !important;
		a{
			color: ${(props) => props.theme.colors.menuLabelActived} !important;
		}
	}
`;

export const LinkRouterStyled = styled(LinkRouter)`
	color: ${(props) => props.theme.colors.menuLabel} !important;
`;

export const DivStyled = styled.div`
	span{
		margin-left: 20px;
		color: ${(props) => props.theme.colors.menuLabel} !important;
	}
`;

export const HeaderStyled = styled.header`
	background: ${(props) => props.theme.colors.header};
	i{
		color: ${(props) => props.theme.colors.iconButton};
	}
	.imgIconMenu{
		filter: ${(props) => props.theme.colors.iconFilter ? 'invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)' : ""};
	}

`;

export const LinkStyledMenu = styled(Link)`
  color: ${(props) => props.theme.colors.menuLabel} !important;
`;

export const H6Styled = styled.h6`
	color: ${(props) => props.theme.colors.headerlabel} !important;
`;
